<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    import HeaderIntro from "../basic/HeaderIntro.svelte";

    export let userSelectionData;
    export let schools;

    let localUserSelectionData = {
        school: undefined,
        class: "",
        kidName: ""
    };

    $: if (JSON.stringify(localUserSelectionData) != JSON.stringify(userSelectionData)) {
        localUserSelectionData = userSelectionData;
    }

    $: dispatch("newUserSelectionData", localUserSelectionData);
</script>

<HeaderIntro mainText={"Dateneingabe"} subText={"Wir benötigen zunächst einige Informationen zu der Bestellung."}/>

<form class="animate__fadeInUp animate__animated">
    <div class="form-group">
      <label for="exampleFormControlSelect1">Schule</label>
      <select bind:value={localUserSelectionData.school} class="form-control" id="exampleFormControlSelect1">
        {#each schools as school}
            <option value={school.code}>{school.city} - {school.name}</option>
        {/each}
      </select>
    </div>
    <div class="form-group">
      <label for="exampleFormControlInput1">Schulklasse</label>
      <input type="text" bind:value={localUserSelectionData.class} class="form-control" id="exampleFormControlInput1" placeholder="z. B. 3b">
    </div>
    <div class="form-group">
        <label for="exampleFormControlInput1">Vor- und Nachname des Kindes</label>
        <input type="text" bind:value={localUserSelectionData.kidName} class="form-control" id="exampleFormControlInput2" placeholder="z. B. Tim Müller">
    </div>
  </form>

  <style>
    select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;
    padding-right: 2rem;
    }
      label {
          padding-bottom: 5px;
      }
      form {
          max-width: 600px;
          margin: 0 auto;
          text-align: left;
      }
      .form-group {
          margin: 22px 0;
      }
      .form-group:first-child {
          margin-top: 0;
      }
  </style>